import { AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import {AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import DataSource from 'devextreme/data/data_source';
import * as Moment from 'moment';
import { BehaviorSubject, of, Subject } from 'rxjs';
import { debounceTime, take, takeUntil } from 'rxjs/operators';
import { DateMoreThan } from '../../../../../shared/custom-validations/date-validations';
import { FusionAuthService } from '../../../../../shared/services/fusion-auth';
import { ClientSelectorComponent } from '../../../../shared/components/client-selector/client-selector.component';
import { ClientService } from '../../../../shared/services';
import { SettingsService } from '../../../../shared/services/settings.service';
import {Client} from "../../../../shared/models/order-entry/client";

function today() {
    return Moment().format('MM/DD/YYYY');
}

@Component({
    selector: 'app-lab-results',
    templateUrl: './lab-results.component.html',
    styleUrls: ['./lab-results.component.scss'],
})
export class LabResultsComponent implements AfterViewInit, OnDestroy {
    @Output() public formSubmitted = new EventEmitter();
    public resultsSearchForm: UntypedFormGroup;
    private sent = false;
    public role: string = '';
    public isLoading = false;
    public showMissingInfo = false;
    // @ts-ignore
  public unitsDataSource: BehaviorSubject<DataSource> = new BehaviorSubject<DataSource>(null);

    private onDestroy$: Subject<void> = new Subject<void>();

    constructor(
        private fb: UntypedFormBuilder,
        private fusionAuthService: FusionAuthService,
        private clientService: ClientService,
        private settingsService: SettingsService,
    ) {
        this.resultsSearchForm = this.fb.group({
            startDate: [today(), [Validators.required]],
            endDate: [today(), [Validators.required, DateMoreThan('startDate')]],
            client: [null],
            unit: [null],
            patient: [null],
            status: [null],
            missingInfo: [false],
            criticalResults: [false],
        });

        this.initialSubmit = this.initialSubmit.bind(this);
    }

    public ngAfterViewInit(): void {
        this.settingsService
            .IsMissingInfoEnabled()
            .pipe(take(1))
            .subscribe(x => {
                this.showMissingInfo = x;
            });
        this.resultsSearchForm.get('client')?.valueChanges
            .pipe(takeUntil(this.onDestroy$))
            .subscribe((client: Client) => {
                if (!client) {
                    // @ts-ignore
                  this.unitsDataSource = new BehaviorSubject<DataSource>(null);
                } else {
                    this.unitsDataSource.next(new DataSource({
                        store: this.clientService.clientUnitsCustomStore(client.id, this.unitsDataSource)
                    }));
                }
            });
        this.initialSubmit();
    }

    private initialSubmit() {
        if (localStorage.getItem('authtoken')) {
            this.role = this.fusionAuthService.Profile.registrations[0].roles[0];

            if (!this.sent) {
                this.submit();
                this.sent = true;
            }
            this.isLoading = false;
        } else {
            this.isLoading = true;
            of()
                .pipe(
                    take(1),
                    debounceTime(1000),
                )
                .subscribe(() => this.initialSubmit());
        }
    }

    get Units(): number {
        return this.resultsSearchForm.get('client')?.value ? this.resultsSearchForm.get('client')?.value.units : null;
    }

    public clear() {
      this.resultsSearchForm.get('startDate')?.setValue(today());
      this.resultsSearchForm.get('endDate')?.setValue(today());
        this.resultsSearchForm.reset();
        this.submit();
    }

    public searchResults(): void {
        if (this.resultsSearchForm.valid) {
            this.submit();
        }
    }

    private submit() {
        if (!this.resultsSearchForm.get('startDate')?.value) {
            this.resultsSearchForm.get('startDate')?.setValue(today());
        }

        if (!this.resultsSearchForm.get('endDate')?.value) {
            this.resultsSearchForm.get('endDate')?.setValue(today());
        }

        this.formSubmitted.emit(this.resultsSearchForm.value);
    }

  public convertToFormControl(absCtrl: AbstractControl | null): UntypedFormControl {
    return absCtrl as UntypedFormControl;
  }

    public ngOnDestroy(): void {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }
}
